import { getMomentDate } from '../utils/commonUtils';
export default class Voucher {
    constructor(data = {}) {
        this.setData(data)
    }

    setData(data = {}) {
        this.id = data.id || undefined;
        this.groupId = data.groupId || undefined;
        this.checkCode = data.checkCode || undefined;
        this.createdBy = data.createdBy || undefined;
        this.createdDate = getMomentDate(data.createdDate);
        this.discountValue = data.discountValue || 0;
        this.groupName = data.groupName || undefined;
        this.hmsVerificationCode = data.hmsVerificationCode || undefined;
        this.properties = data.properties || undefined;
        this.isExpired = data.isExpired || false;
        this.isLocked = data.isLocked || false;
        this.limitNumberOfTimes = data.limitNumberOfTimes || 0;
        this.maxDiscountValue = data.maxDiscountValue || 0;
        this.maxOrderValue = data.maxOrderValue || 0;
        this.minOrderValue = data.minOrderValue || 0;
        this.salePrice = data.salePrice || undefined;
        this.serialNumber = data.serialNumber || undefined;
        this.status = data.status || undefined;
        this.usedCount = data.usedCount || 0;
        this.voucherType = data.voucherType || undefined;
        this.currencyCode = data.currencyCode || undefined;
        this.checkInDate = getMomentDate(data.checkInDate);
        this.checkOutDate = getMomentDate(data.checkOutDate);
        this.operaBookingCode = data.operaBookingCode || undefined;
        this.propertyOfStay = data.propertyOfStay || undefined;
        this.checkedDate = getMomentDate(data.checkedDate);
        this.startDate = getMomentDate(data.startDate);
        this.endDate = getMomentDate(data.endDate);
    }

    export() {
        return {
            id: this.id,
            groupId: this.groupId,
            checkCode: this.checkCode,
            createdBy: this.createdBy,
            createdDate: this.createdDate && this.createdDate.toISOString(),
            discountValue: this.discountValue,
            groupName: this.groupName,
            hmsVerificationCode: this.hmsVerificationCode,
            isExpired: this.isExpired,
            isLocked: this.isLocked,
            limitNumberOfTimes: this.limitNumberOfTimes,
            maxDiscountValue: this.maxDiscountValue,
            maxOrderValue: this.maxOrderValue,
            minOrderValue: this.minOrderValue,
            salePrice: this.salePrice,
            serialNumber: this.serialNumber,
            status: this.status,
            usedCount: this.usedCount,
            voucherType: this.voucherType,
            currencyCode: this.currencyCode,
            checkInDate: this.checkInDate && this.checkInDate.toISOString(),
            checkOutDate: this.checkOutDate && this.checkOutDate.toISOString(),
            operaBookingCode: this.operaBookingCode
        }
    }
}

export class VoucherHistory {
    constructor(data = {}) {
        this.setData(data)
    }

    setData(data = {}) {
        this.id = data.id || undefined;
        this.voucherId = data.voucherId || undefined;
        this.actionId = data.actionId || undefined;
        this.actionBy = data.actionBy || undefined;
        this.actionDate = getMomentDate(data.actionDate);
        this.note = data.note || undefined;
    }

    export() {
        return {
            id: this.id,
            voucherId: this.voucherId,
            actionId: this.actionId,
            actionBy: this.actionBy,
            actionDate: this.actionDate && this.actionDate.toISOString(),
            note: this.note,
        }
    }
}